import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { OrganizationService } from "../../../services/ClientService";

export default function OrganizationPage() {
    const { active } = useParams<{ active?: string }>();

    const [errorMessage, setErrorMessage] = useState("");

    const never = "never" as const;

    const [columns, setColumns] = useState([
        {
            title: "ID",
            field: "id",
            editable: never,
        },
        {
            title: "Name",
            field: "name",
        },
        {
            title: "Active",
            field: "active",
            type: "boolean" as const,
        },
    ]);

    const [data, setData] = useState([] as APIModels.Organization[]);

    const refreshData = () => {
        OrganizationService.getList({
            active:
                active === "active"
                    ? true
                    : active === "inactive"
                    ? false
                    : undefined,
        }).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    setData(resp.data);
                } else {
                    setData([]);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    // useEffect(() => {
    //     refreshData();
    // }, [data]);

    const onEdit = (rowdata: APIModels.Organization) => {
        window.location.href = `/admin/organizationedit/${rowdata.id}`;
        console.log(rowdata.id);
    };

    const onDelete = (rowData: APIModels.Organization) => {
        OrganizationService.delete({
            id: rowData.id!,
        }).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    refreshData();
                } else {
                    setErrorMessage("An error has occurred");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        if (errorMessage !== "") {
            console.log(errorMessage);
            setErrorMessage("");
        }
    };

    useEffect(() => {
        refreshData();
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Rules</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Organizations
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <MaterialTable
                                columns={columns}
                                data={data}
                                title="Organizations"
                                options={{
                                    actionsColumnIndex: -1,
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                actions={[
                                    {
                                        icon: "edit",
                                        tooltip: "Edit an organization",
                                        onClick: (event, rowData) =>
                                            onEdit(
                                                rowData as APIModels.Organization
                                            ),
                                    },
                                    {
                                        icon: "delete",
                                        tooltip: "Delete an organization",
                                        onClick: (event, rowData) =>
                                            onDelete(
                                                rowData as APIModels.Organization
                                            ),
                                    },
                                ]}
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            OrganizationService.add({
                                                body: newData,
                                            }).then(
                                                (_resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
